export default __webpack_public_path__ + "static/media/yeild_guild.edae8f83.png";